import React, { Component } from 'react';

//TODO: barre su valori minimo e massimo,e scrivere i decibel:
// https://stackoverflow.com/questions/14169317/interpreting-web-audio-api-fft-results
// https://stackoverflow.com/questions/14789283/what-does-the-fft-data-in-the-web-audio-api-correspond-to

class WaveVisualizer extends Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
  }

  componentDidUpdate() {
    this.draw();
  }

  draw() {
    const { waveData, rmsValue } = this.props;
    const canvas = this.canvas.current;
    const height = canvas.height;
    const width = canvas.width;
    const context = canvas.getContext('2d');
    let x = 0;
    if(!waveData)return;
    const sliceWidth = (width * 1.0) / waveData.length;

    context.lineWidth = 2;
    context.strokeStyle = '#000000';
    context.clearRect(0, 0, width, height);
    // background:

    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, width, height);

    // grid
    context.lineWidth = 1;
    context.strokeStyle = '#B3B3B3';
    context.fillStyle = 'rgba(0,0,0,0)';
    context.beginPath();
    // vertical
    context.moveTo(0, 0);
    context.lineTo(0, height);
    context.moveTo(width / 4, 0);
    context.lineTo(width / 4, height);
    context.moveTo(width / 2, 0);
    context.lineTo(width / 2, height);
    context.moveTo((width * 3) / 4, 0);
    context.lineTo((width * 3) / 4, height);
    context.moveTo(width, 0);
    context.lineTo(width, height);
    // horizontal
    context.moveTo(0, (height * 3) / 4);
    context.lineTo(width, (height * 3) / 4);
    context.moveTo(0, height / 4);
    context.lineTo(width, height / 4);
    context.stroke();

    if (rmsValue) {
      context.strokeStyle = '#FF5073';
      context.beginPath();
      context.moveTo(0, (height / 2) * (1 - rmsValue));
      context.lineTo(width, (height / 2) * (1 - rmsValue));
      context.moveTo(0, (height / 2) * (1 + rmsValue));
      context.lineTo(width, (height / 2) * (1 + rmsValue));
      context.stroke();
    }

    context.strokeStyle = 'black';
    context.beginPath();
    context.moveTo(0, height / 2);
    for (const item of waveData) {
      var v = item * height;
      const y = height / 2 + v;

      //const y = (item / 255.0) * height;
      context.lineTo(x, y);
      x += sliceWidth;
    }
    context.lineTo(x, height / 2);
    context.stroke();
  }

  render() {
    return (
      <div id="wavevisualizer">
        <canvas width="500" height="256" ref={this.canvas} />
      </div>
    );
  }
}

export default WaveVisualizer;
